module.exports = __webpack_public_path__ + "img/verification-active.8f538459.svg";